module.exports = __webpack_public_path__ + "img/314097f.png";